import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { urlSafeB64Encode } from "../utils/encoding";
import { apiFetch } from "./client";
import { qualificationPdfQueryKey } from "./queryKeys";

export function useGetQualificationPdf(bomId, options = {}) {
  return useQuery({
    queryKey: qualificationPdfQueryKey(bomId),
    queryFn: () => apiFetch(`/extras/api/v1/boms/qualification-pdf/${urlSafeB64Encode(bomId)}`),
    ...options,
  });
}

export function useGenerateQualificationPdf() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bomId }) => apiFetch(`/extras/api/v1/boms/qualification-pdf/${urlSafeB64Encode(bomId)}`, { method: "POST" }),
    onSuccess: (_data, { bomId }) => {
      queryClient.invalidateQueries({ queryKey: qualificationPdfQueryKey(bomId) });
    },
  });
}
